import React, { useEffect, useState } from "react";
import {
  Collapse,
  CardHeader,
  CardContent,
  TextField,
  FormControl,
  InputLabel,
  Select,
  MenuItem,
  Dialog,
  FormControlLabel,
  Checkbox,
  OutlinedInput,
  Typography,
  FormLabel,
  RadioGroup,
  Radio,
  FormHelperText,
} from "@material-ui/core";

import ChipInput from "material-ui-chip-input";
import StepperPage from "./StepperPage";
import { makeStyles } from "@material-ui/core/styles";
import { Trans, useTranslation } from "react-i18next";
import { DatePicker } from "@material-ui/pickers";
import TaxonomySelector from "../taxonomy/TaxonomySelector";
import CustomFields from "../customfields/CustomFields";
import axios from "../../AxiosClient";
import Alert from "@material-ui/lab/Alert";
import { Role, currentUserHasRole } from "../../utils/RoleUtils";
import DocumentType from "../DocumentType";
import { useSelector } from "react-redux";
import { connect } from "react-redux";
import { withTranslation } from "react-i18next";
import KpsTextField from "../KpsTextField";
import DocumentCategories from "../document/DocumentCategories";
const useStyles = makeStyles((theme) => ({
  formControl: {
    marginTop: 10,
  },
}));
function ContentSetup(props) {
  const [topicTouched, setTopicTouched] = useState(false);
  const [taxonomySelectorError, setTaxonomySelectorError] = useState(true);
  const [maxClassification, setMaxClassification] = useState(5);
  const [workflow, setWorkflow] = useState(null);
  const [requiresWorkflow, setRequiresWorkflow] = useState(false);
  const { t } = useTranslation();
  const classes = useStyles();
  const documentTypes = useSelector((state) => state.prefs.documentTypes);

  useEffect(() => {
    let check = checkIfCustomFieldsComplete();
    check && props.setNextDisabled(true);
    props.setDisabledHelperText(
      <Trans i18nKey="create_content_select_topic_button_disabled">
        create_content_select_topic_button_disabled
      </Trans>
    );
    props.updateContent({
      ...props.content,
      publishContent: false,
      makeDraft: props.createRevision ? false : true,
    });
  }, []);

  // useEffect(() => {
  //   checkIfCustomFieldsComplete();
  // }, [props.currentCustomFields]);

  useEffect(
    () => {
      if (props.content.topicId) {
        let url = `/knowledgesource/topic/${props.content.topicId}/expert/`;
        if (props.content.classification) {
          url = `/knowledgesource/topic/${props.content.topicId}/expert/${
            props.content.classification ? props.content.classification : 0
          }/`;
        }
        axios.get(url, { withCredentials: true }).then((res) => {
          if (!res.data || res.data.length === 0) {
            axios
              .get(
                `/knowledgesource/workflow/${props.content.topicId}/${
                  props.content.classification
                    ? props.content.classification
                    : 0
                }`,
                { withCredentials: true }
              )
              .then((res) => {
                processWorkflow(res.data);
              });
          } else {
            processWorkflow(res.data[0].workflow);
          }
        });
      }
    },
    [props.content.classification, props.content.topicId]
  );
  const checkIfCustomFieldsComplete = () => {
    let check = true;
    props.currentCustomFields.map((cf) => {
      if ((cf.value === "" || cf.value === null) && cf.mandatory === true) {
        check = false;
      }
    });
    return check;
  };
  const processWorkflow = (ksWorkflow) => {
    setWorkflow(ksWorkflow);
    if (ksWorkflow.approversRequired > 0 || ksWorkflow.reviewersRequired > 0) {
      setRequiresWorkflow(true);
      props.updateContent({
        ...props.content,
        publishContent: false,
      });
    } else {
      if (ksWorkflow.publishRequired) {
        if (currentUserHasRole(Role.PUBLISHER)) {
          setRequiresWorkflow(false);
        } else {
          setRequiresWorkflow(true);
          props.updateContent({
            ...props.content,
            publishContent: false,
          });
        }
      } else {
        setRequiresWorkflow(false);
      }
    }
  };

  useEffect(
    () => {
      let check = checkIfCustomFieldsComplete();
      if ((!props.content.topicId && !props.revisionEdit) || !check) {
        props.setNextDisabled(true);
      } else {
        props.setNextDisabled(false);
      }
    },
    [props.content, props.currentCustomFields]
  );

  const radioChange = (e) => {
    if (e.target.value === "draft") {
      props.updateContent({
        ...props.content,
        publishContent: false,
        makeDraft: true,
      });
    } else if (e.target.value === "publish") {
      props.updateContent({
        ...props.content,
        publishContent: true,
        makeDraft: false,
      });
    } else {
      props.updateContent({
        ...props.content,
        publishContent: false,
        makeDraft: false,
      });
    }
  };

  const setTopic = (node) => {
    node.object &&
      props.updateContent({
        ...props.content,
        topicId: node.object.topicId,
        classification: 0,
      });
    setTaxonomySelectorError(false);
    setMaxClassification(
      node.maxExpertClassification == null ? 5 : node.maxExpertClassification
    );
  };

  const getDraftText = () => {
    if (!workflow) {
      return t("content_setup_make_draft");
    }
    if (workflow.reviewersRequired > 0) {
      return "Submit for review";
    }
    if (workflow.approversRequired > 0) {
      return "Submit for approval";
    }
    if (workflow.publishRequired && !currentUserHasRole(Role.PUBLISHER)) {
      return "Submit for publishing";
    }
    return t("content_setup_make_draft");
  };

  const getRadioValue = () => {
    if (!workflow) {
      return "";
    }
    if (props.content.publishContent) {
      return "publish";
    } else {
      if (props.content.makeDraft) {
        return "draft";
      }
    }
    return "";
  };

  const changeDocType = (e) => {
    props.updateContent({
      ...props.content,
      documentTypeId: e.target.value,
    });
  };

  const changeCategories = (categories) => {
    props.updateContent({
      ...props.content,
      categories: categories.map((c) => c.id),
    });
  };

  return (
    <div style={{ width: "100%", overflow: "auto" }}>
      <div>
        <Typography variant="h5">
          {props.edit ? (
            <Trans i18nKey="edit_content_setup_header">
              edit_content_setup_header
            </Trans>
          ) : (
            <Trans i18nKey="create_content_setup_header">
              create_content_setup_header
            </Trans>
          )}
        </Typography>
        <Typography variant="body2" gutterBottom>
          {props.edit ? (
            <Trans i18nKey="edit_content_setup_subheader">
              edit_content_setup_subheader
            </Trans>
          ) : (
            <Trans i18nKey="create_content_setup_subheader">
              create_content_setup_subheader
            </Trans>
          )}
        </Typography>
      </div>
      <div style={{ marginLeft: 5, marginTop: 10 }}>
        <Typography variant="h6">{props.content.title}</Typography>
        {props.template && (
          <Typography variant="body2">
            <Trans i18nKey="template_confirm_template_name" />:{" "}
            {props.template.name}
          </Typography>
        )}
      </div>
      <div
        style={{
          marginLeft: 5,
          marginTop: 5,
          display: "flex",
        }}
      >
        <div
          style={{
            display: "flex",
            flexDirection: "column",
            flex: 1,
            borderRight: "1px solid gray",
            paddingRight: 20,
          }}
        >
          <div style={{ display: "flex", marginBottom: 5 }}>
            <div style={{ flex: 2, marginRight: 20 }}>
              <TaxonomySelector
                showExpertStatus
                fullWidth
                showWorkflow
                error={topicTouched && taxonomySelectorError}
                onTouch={() => setTopicTouched(true)}
                disabled={props.edit}
                inputLabel={"Select a Topic"}
                allowedSelections={["topic"]}
                filter={
                  props.content.topicId
                    ? [{ id: props.content.topicId, type: "topic" }]
                    : []
                }
                onNodeSelected={setTopic}
                treeType="expert"
              />
              <FormHelperText
                style={{ margin: 0 }}
                error={topicTouched && taxonomySelectorError}
                id="component-error-text"
              >
                <Trans i18nKey="global_required" />
              </FormHelperText>
            </div>
            <FormControl style={{ flex: 1 }}>
              <InputLabel>
                <Trans i18nKey="add_section_classification" />
              </InputLabel>
              <Select
                onClick={(e) => {
                  props.updateContent({
                    ...props.content,
                    classification: e.target.value,
                  });
                }}
                value={
                  props.content.classification
                    ? props.content.classification
                    : 0
                }
              >
                <MenuItem value={0} disabled={maxClassification < 0}>
                  Public
                </MenuItem>
                <MenuItem value={1} disabled={maxClassification < 1}>
                  Level 1
                </MenuItem>
                <MenuItem value={2} disabled={maxClassification < 2}>
                  Level 2
                </MenuItem>
                <MenuItem value={3} disabled={maxClassification < 3}>
                  Level 3
                </MenuItem>
                <MenuItem value={4} disabled={maxClassification < 4}>
                  Level 4
                </MenuItem>
                <MenuItem value={5} disabled={maxClassification < 5}>
                  Level 5
                </MenuItem>
              </Select>
            </FormControl>
          </div>
          <div style={{ display: "flex", marginBottom: 5 }}>
            <div>
              <DocumentType
                disabled={props.edit}
                doctypes={documentTypes}
                docTypeSelected={changeDocType}
                documentType={[
                  props.content.documentTypeId
                    ? props.content.documentTypeId
                    : props.template
                      ? props.template.documentTypeId
                      : -1,
                ]}
              />
              <FormHelperText style={{ margin: 0 }}>
                <Trans i18nKey="content_setup_doc_type_helper_text" />
              </FormHelperText>
            </div>
            <DocumentCategories
              onChange={changeCategories}
              disabled={props.edit}
              defaultValue={props.content.categories}
              style={{ marginLeft: 10 }}
            />
          </div>
          {requiresWorkflow && (
            <Alert severity="info" style={{ marginTop: 10 }}>
              <Trans i18nKey="content_setup_workflow_active" />
            </Alert>
          )}
          <FormControl style={{ marginTop: 20 }}>
            <FormLabel>
              <Trans i18nKey="content_status" />
            </FormLabel>
            <RadioGroup value={getRadioValue()} onChange={radioChange}>
              <FormControlLabel
                value="publish"
                control={<Radio />}
                label="Publish"
                disabled={
                  (!props.content.topicId && !props.edit) ||
                  !workflow ||
                  requiresWorkflow
                }
              />
              <FormControlLabel
                value="draft"
                control={<Radio />}
                label={getDraftText()}
                disabled={(!props.content.topicId && !props.edit) || !workflow}
              />
              <FormControlLabel
                value=""
                control={<Radio />}
                label="In progress"
                disabled={(!props.content.topicId && !props.edit) || !workflow}
              />
            </RadioGroup>
            <FormHelperText>
              {!workflow && (
                <Trans i18nKey="content_setup_status_select_topic">
                  content_setup_status_select_topic
                </Trans>
              )}
              {workflow &&
                requiresWorkflow && (
                  <Trans i18nKey="content_setup_cannot_publish_workflow_required">
                    content_setup_cannot_publish_workflow_required
                  </Trans>
                )}
              {workflow &&
                !requiresWorkflow && (
                  <Trans i18nKey="content_setup_publish_status_helper_text">
                    content_setup_publish_status_helper_text
                  </Trans>
                )}
            </FormHelperText>
          </FormControl>
          {!props.edit && (
            <KpsTextField
              label={t("content_description_label")}
              aria-label="Content description text input"
              helperText={t("content_description_helper_text")}
              value={props.content.description}
              onChange={(value) =>
                props.updateContent({
                  ...props.content,
                  description: value.target.value,
                })
              }
            />
          )}
          <ChipInput
            fullWidthInput
            value={Array.isArray(props.content.meta) ? props.content.meta : []}
            onAdd={(chip) =>
              props.updateContent({
                ...props.content,
                meta: [...props.content.meta, chip],
              })
            }
            onDelete={(chip, idx) => {
              let clone = JSON.parse(JSON.stringify(props.content.meta));
              clone.splice(idx, 1);
              props.updateContent({
                ...props.content,
                meta: [...clone],
              });
            }}
            label={t("content_meta_label")}
            helperText={t("content_meta_helper_text")}
            newChipKeyCodes={[9, 13, 32]}
            blurBehavior={"add"}
          />
        </div>

        <div style={{ flex: 1, paddingLeft: 20 }}>
          <FormControlLabel
            className={classes.formControl}
            style={{ marginTop: "24px" }}
            control={
              <Checkbox
                onChange={(event, value) =>
                  props.updateContent({
                    ...props.content,
                    requiresReval: value,
                  })
                }
                value={props.content.requiresReval}
              />
            }
            label={t("content_setup_requires_revalidation")}
          />
          <Collapse in={props.content.requiresReval} id="revalidationCollapse">
            <div
              style={{
                display: "flex",
                flexDirection: "column",
                flex: 1,
                marginRight: 20,
              }}
            >
              <FormControl className={classes.formControl}>
                <InputLabel id="reval-behaviour-label">
                  {t("content_setup_revalidation_behaviour")}
                </InputLabel>
                <Select
                  labelId="reval-behaviour-label"
                  id="reval-behaviour"
                  value={props.content.revalidationBehaviour}
                  onChange={(event) =>
                    props.updateContent({
                      ...props.content,
                      revalidationBehaviour: event.target.value,
                    })
                  }
                >
                  <MenuItem value={"DO_NOTHING"}>
                    {t("content_setup_do_nothing")}
                  </MenuItem>
                  <MenuItem value={"DISPLAY_WARNING"}>
                    {t("content_setup_display_a_warning")}
                  </MenuItem>
                  <MenuItem value={"HIDE_DOCUMENT"}>
                    {t("content_setup_hide_document")}
                  </MenuItem>
                  <MenuItem value={"NOT_SET"}>
                    {t("content_setup_none_set")}
                  </MenuItem>
                </Select>
              </FormControl>
              <FormControl variant="outlined" className={classes.formControl}>
                <DatePicker
                  minDate={new Date()}
                  autoOk
                  label={t("content_setup_revalidation_date")}
                  clearable
                  value={props.content.revalidationDate}
                  onChange={(date) =>
                    props.updateContent({
                      ...props.content,
                      revalidationDate: date,
                    })
                  }
                />
              </FormControl>
            </div>
          </Collapse>
          <FormControlLabel
            className={classes.formControl}
            style={{ marginTop: "24px" }}
            control={
              <Checkbox
                onChange={(event, value) =>
                  props.updateContent({
                    ...props.content,
                    visiblityDates: value,
                  })
                }
                value={props.content.visiblityDates}
              />
            }
            label={t("content_setup_visibility_date_range")}
          />
          <Collapse in={props.content.visiblityDates}>
            <div
              style={{
                display: "flex",
                flexDirection: "column",
                flex: 1,
                marginRight: 20,
              }}
            >
              <FormControl variant="outlined" className={classes.formControl}>
                <DatePicker
                  minDate={new Date()}
                  autoOk
                  label={t("content_setup_visible_from")}
                  clearable
                  value={props.content.visibleDate}
                  onChange={(date) =>
                    props.updateContent({
                      ...props.content,
                      visibleDate: date,
                    })
                  }
                />
              </FormControl>
              <FormControl variant="outlined" className={classes.formControl}>
                <DatePicker
                  minDate={props.content.visibleDate}
                  disabled={!props.content.visibleDate}
                  autoOk
                  label={t("content_setup_visible_to")}
                  clearable
                  value={props.content.expiryDate}
                  onChange={(date) =>
                    props.updateContent({
                      ...props.content,
                      expiryDate: date,
                    })
                  }
                />
              </FormControl>
            </div>
          </Collapse>
        </div>
      </div>
      <div class="padding">
        <CustomFields templateId={props.template} createContent contentSetup />
      </div>
    </div>
  );
}
const mapStateToProps = (state) => ({
  currentCustomFields: state.customFields.currentCustomFields,
});
const mapDispatchToProps = {};
export default connect(
  mapStateToProps,
  mapDispatchToProps
)(withTranslation()(StepperPage(ContentSetup)));
